export const notFoundValue = 'notFound';
export const notInstallBaseRelated = 'notInstallBaseRelated';
